import { Avatar, Box, Tab, Tabs } from '@mui/material'
import { useAuth } from 'contexts/auth'
import { SyntheticEvent } from 'react'
import { useParams } from 'react-router-dom'
import useContract from 'store/contracts'
import { formatCNPJ } from 'utils/is-valid-cnpj'
import { stringToAvatar } from 'utils/string-to-avatar'
import ContractStatus from '../status'
import { useStyles } from './styles'

interface IRouteParams {
  organizationId: string
  contractId: string
  tagId: string
}

const ContractsHeader = () => {
  const { actualOrganization, updateTab, actualTab } = useContract()
  const { contractId } = useParams<IRouteParams>()
  const { user } = useAuth()

  const classes = useStyles()

  const handleChangeTab = (_: SyntheticEvent, newValue: number) => updateTab(newValue)

  const tabOptions = ['Contratos', 'Ferramentas']

  let backroute = '/customers'

  if (user && !user.isSeller) {
    backroute = `/dashboard`
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.containerBase}>
        <section>
          <span className={classes.title}>Cliente</span>
          <div className={classes.containerInfo}>
            <Avatar {...stringToAvatar(actualOrganization.name, '#BDBDBD')} />

            <Box className={classes.groupText}>
              <span style={{ fontWeight: 600 }}>{actualOrganization.name}</span>
              <span className={classes.subTitle}>{formatCNPJ(actualOrganization.federalTaxId, false)}</span>
            </Box>

            <ContractStatus status='active' />
          </div>
        </section>
      </Box>

      <Tabs
        value={actualTab}
        onChange={handleChangeTab}
        aria-label='Project Tabs'
        sx={{ marginTop: '1rem' }}
      >
        {tabOptions.map((tab, index) => (
          <Tab
            label={tab}
            key={index}
            id={`simple-tab-${index}`}
            aria-controls={`simple-tabpanel-${index}`}
          />
        ))}
      </Tabs>
    </Box>
  )
}

export default ContractsHeader
